/**
 * Read a CSV file as UTF-8 text (browser File API with FileReader fallback for Jest).
 *
 * @param {File|Blob} file
 * @returns {Promise<string>}
 */
export async function readCsvFileAsText(file) {
  if (!file) {
    throw new Error('No file provided');
  }
  if (typeof file.text === 'function') {
    return file.text();
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ''));
    reader.onerror = () => reject(reader.error || new Error('File read failed'));
    reader.readAsText(file);
  });
}
